/*
* Inicialización de variables
*/

const p = new Array()
let x, variants, locale;
let tasa_HNL = 3.32233 // valor de 1 GTQ A NHL
let quotes = 18 // Valor de quotas para cálculo

localStorage.setItem("tasa_HNL", tasa_HNL);
localStorage.setItem("quotes", quotes);

/*
* Guardado del url param (Tamano) en el localstorage.
*/
function SaveParamsFiltersLocalStorage(){
  const urlParams = new URLSearchParams(window.location.search);
  const varTamanoValues = urlParams.getAll('filter.v.m.custom.var_tamano');
  varTamanoValues == 'Matrimonial' ? localStorage.setItem("Tamano", 'Matri') : localStorage.setItem("Tamano", varTamanoValues);
}

SaveParamsFiltersLocalStorage();

/*
* Watcher detecta cambios en el filtro de tamaño en el DOM 
*/
document.addEventListener("DOMContentLoaded", function () {
  const targetNode = document.getElementById("Details-3-template--18760738406614__product-grid");
  if (!targetNode) return;
  const observeR = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        SaveParamsFiltersLocalStorage();
        window.location.reload();
      }
    }
  });
  observeR.observe(targetNode, { childList: true, subtree: true }); // Instancia del Observer
});

/*
* Script iconos personalizados en Megamenu
*/
let loop_container = document.querySelector('#ProductGridContainer');
let menus = ['.meganav-1', '.meganav-2'];

function setIconsMegamenu(menuClass){
  menuClass.forEach(menu => {
    let megaMenu = document.querySelector(menu);
    const colsCats = Array.from(megaMenu.getElementsByClassName('mega-col-inner'));
    //console.log(megaMenu)
    if(megaMenu != undefined){
      colsCats.forEach(item => {
        const labels = item.querySelectorAll('.menu-title a');
        labels.forEach(label => {
            switch(label.innerHTML){
              case 'Imperial':
              label.setAttribute('class','set-icon set-icon-imperial');
              break;
              case 'Semi':
              label.setAttribute('class','set-icon set-icon-semi');
              break;
              case 'Matrimonial':
              label.setAttribute('class','set-icon set-icon-matri');
              break;
              case 'Queen':
              label.setAttribute('class','set-icon set-icon-queen');
              break;
              case 'King':
              label.setAttribute('class','set-icon set-icon-king');
              break;
              case 'In Box':
              label.setAttribute('class','set-icon set-icon-in-box');
              break;
            }
        });
      });
    }
  });
}

setIconsMegamenu(menus);

// segunda recarga de pagina

function detectAndReload() {
  menus.forEach(menu => {
    let megaMenu = document.querySelector(menu);

    if (megaMenu) {
      const allLinks = megaMenu.querySelectorAll('a'); 

      allLinks.forEach(link => {
        link.addEventListener('click', function () {
          sessionStorage.setItem('secondReload', 'true'); 
        });
      });
    }
  });
}

// Si la marca de recarga está en sessionStorage, recargar y eliminarla
window.addEventListener("load", () => {
  if (sessionStorage.getItem('secondReload')) {
    sessionStorage.removeItem('secondReload');
    setTimeout(() => {
      window.location.reload();
    }, 50); 
  }
});

// Ejecutar la función
detectAndReload();

window.addEventListener("pageshow", (event) => {
    if (event.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward") {
        let reloadCount = sessionStorage.getItem("reloadCount") || 0;
        
        if (reloadCount < 2) {
            sessionStorage.setItem("reloadCount", ++reloadCount);
            location.reload();
        } else {
            sessionStorage.removeItem("reloadCount"); // Evita que siga recargando
        }
    }
});


//- Modal - instructivo de pagos
/*document.addEventListener("DOMContentLoaded", function () {
    const checkoutButtons = document.querySelectorAll(".js-cart-btn-checkout");
    const modal = document.getElementById("modal-information");
    const confirmButton = document.getElementById("confirmar");
    const cancelButton = document.getElementById("cancelar");
    let destinationUrl = "";
    let isModalOpen = false;

    if (!modal || !confirmButton || !cancelButton || checkoutButtons.length === 0) {
        console.warn("Some required elements are missing in the DOM.");
        return;
    }

    // Function to detect and store the redirection URL
    function storeRedirectionUrl(element) {
        if (element.tagName === "A") {
            return element.href; // If it's a link, use its href
        }
    }

    // Function to open the modal and prevent redirection
    function showModal(e) {
        e.preventDefault(); // Prevents immediate redirection (for <a>)
        e.stopImmediatePropagation(); // Stops any other scripts from handling the event

        if (!isModalOpen) {
            destinationUrl = storeRedirectionUrl(e.currentTarget); // Store the redirection URL
            modal.classList.add("visible"); // Show the modal
            isModalOpen = true;
        }
    }

    // Prevent redirection while the modal is open
    function preventRedirection(e) {
        if (isModalOpen) {
            e.preventDefault();
            //e.stopImmediatePropagation();
        }
    }

    // Add event listeners to all checkout buttons
    checkoutButtons.forEach(button => {
        button.addEventListener("click", showModal, true); // Capture phase to intercept early
        button.addEventListener("click", preventRedirection, true);
    });

    // Confirm action and allow redirection
    confirmButton.addEventListener("click", function () {
        modal.classList.remove("visible"); // Hide the modal
        isModalOpen = false;
        if (destinationUrl) {
            window.location.href = destinationUrl; // Perform the stored redirection
        }
    });

    // Cancel action and close the modal
    cancelButton.addEventListener("click", function () {
        modal.classList.remove("visible"); // Hide the modal
        isModalOpen = false;
        destinationUrl = ""; // Reset the redirection URL
    });
});*/

//-- Script para boton de pago en single page

/*document.addEventListener("DOMContentLoaded", function () {
    const buyNowButton = document.querySelector(".shopify-payment-button__button");

    if (!buyNowButton) {
        console.warn("No se encontró el botón de pago de Shopify.");
        return;
    }

    buyNowButton.addEventListener("click", function (event) {
        event.preventDefault(); // Evita la redirección inmediata
        event.stopImmediatePropagation(); // Evita que otros eventos en el mismo elemento se ejecuten

        setTimeout(() => {
            const userConfirmed = confirm("Información - Métodos de pago \n\n *Selecciona QPaypro para pagos con NeoNet. \n *Si quieres pagar con BAC usa TiloPay");
        }, 500); // Espera 500ms antes de mostrar el confirm
    });
});*/


/*document.addEventListener("DOMContentLoaded", function () {
    const buyNowButton = document.querySelector(".shopify-payment-button__button");

    if (!buyNowButton) {
        console.warn("No se encontró el botón de pago de Shopify.");
        return;
    }

    let destinationUrl = ""; // Variable para almacenar la URL de redirección

    // Función para detectar cambios en la URL con delay
    function detectRedirectionUrl() {
        destinationUrl = window.location.href;
        console.log("⚡ URL de redirección capturada:", destinationUrl);
        history.pushState(null, "", window.location.href); // Evita la redirección inmediata
    }

   

    // Interceptamos el clic en el botón de "Comprar ahora"
    buyNowButton.addEventListener("click", function (event) {
        event.preventDefault();
        // Observador para detectar cambios en la URL
        const observer = new MutationObserver(detectRedirectionUrl);
        observer.observe(document, { subtree: true, childList: true });
        event.stopImmediatePropagation();

        setTimeout(() => {
            Swal.fire({
                title: "¿Deseas continuar con la compra?",
                text: "Serás redirigido al proceso de pago.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, continuar",
                cancelButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed && destinationUrl) {
                    console.log("✅ Usuario confirmó. Redirigiendo a:", destinationUrl);
                    window.location.href = destinationUrl; // Redirige a la URL capturada
                } else {
                    console.log("❌ Usuario canceló la compra.");
                }
            });
        }, 500); // Espera 500ms antes de mostrar el SweetAlert
    }, true);
});*/





//- Acceso a pagina de tiendas (Sucursales)
 const contHeaderAccess = document.querySelector(".header-bottom__right");
    
    if (!contHeaderAccess) {
        console.warn("El contenedor '.header-bottom__right' no se encontró en el DOM.");
    } else {
        const linkPageStores = "https://lacolchoneria.co/pages/tiendas/";
        const iconMarker = "https://cdn.shopify.com/s/files/1/0729/7931/6950/files/prime--map-marker.svg?v=1741965671";

        const imgEle = document.createElement("img");
        Object.assign(imgEle, {
            src: iconMarker,
            alt: "Tiendas",
            title: "Tiendas",
            width: 24,
            height: 24,
            loading: "lazy"
        });

        const linkMapEle = document.createElement("a");
        Object.assign(linkMapEle, {
            href: linkPageStores,
            rel: "noopener noreferrer",
            title: "Ver tiendas"
        });

        const labelBtn = document.createElement("span");
        labelBtn.classList.add("label-store-link");
        linkMapEle.classList.add("link-access-store");

        const label = document.createTextNode(" Tiendas");

        labelBtn.appendChild(label);
        linkMapEle.appendChild(imgEle);
        linkMapEle.appendChild(labelBtn);
        contHeaderAccess.appendChild(linkMapEle);
    }

  // Bug header sobre puesto al dar scrolldown
 /* (function () {
    let lastScrollTop = 0;
    let maxHeight = window.innerWidth < 991 ? "100px" : "155px";
    const header = document.querySelector("#shopify-section-header");

    if (!header) {
        console.warn("Elemento #shopify-section-header no encontrado.");
        return;
    }
    
    // Aplicar transición CSS
    header.style.transition = "max-height 0.24s ease";
    
    const updateMaxHeight = () => {
        maxHeight = window.innerWidth < 991 ? "100px" : "155px";
        header.style.maxHeight = maxHeight;
    };

    const onScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop) {
            header.style.maxHeight = "0px";
        } else {
            header.style.maxHeight = maxHeight;
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };

    window.addEventListener("scroll", () => requestAnimationFrame(onScroll));
    window.addEventListener("resize", () => requestAnimationFrame(updateMaxHeight));
    
    // Inicializar con el valor correcto al cargar la página
    updateMaxHeight();
})();*/







